import { isWeb } from "@helpers/platform";
import { useAppTheme } from "@hooks/useAppTheme";
import { Box, CustomChip, PremiumIcon, useDevice } from "@memorang/ui";
import type { ReactNode } from "react";
import { Text } from "react-native-paper";

export const SectionHeader = ({
	sectionTitle,
	chipProps,
	handleClickChips,
	rightElement,
}: {
	sectionTitle: string;
	chipProps?: {
		label: string;
		background?: string;
		isPremium?: boolean;
	};
	handleClickChips?: () => void;
	rightElement?: ReactNode;
}) => {
	const { isMobile } = useDevice();
	const theme = useAppTheme();

	return (
		<Box
			justifyContent="space-between"
			alignItems="center"
			flexDirection="row"
			paddingRight={isWeb && !isMobile ? 0 : 16}
			paddingLeft={isMobile ? 16 : 0}
			style={{
				paddingTop: 0,
				paddingBottom: 0,
			}}
		>
			<Text
				accessibilityRole="header"
				style={{
					color: theme.colors.onSurface,
					fontWeight: "bold",
				}}
				variant="titleMedium"
			>
				{sectionTitle}
			</Text>
			{rightElement ??
				(chipProps && (
					<CustomChip
						onPress={handleClickChips}
						icon={() => <PremiumIcon size={16} color={theme.colors.black} />}
						style={{
							backgroundColor: chipProps.background,
						}}
						textStyle={{
							color: theme.colors.black,
						}}
					>
						{chipProps.label}
					</CustomChip>
				))}
		</Box>
	);
};
